import { useMemo } from 'react';
import { useServerConfigSelector } from 'src/core/config/hooks';

const useProcessOverview = (): {
  overviewSteps: string[];
} => {
  const {
    config: { registerOnlyFlow },
  } = useServerConfigSelector();

  const registerOverviewSteps = {
    accountData: 'accountData',
    investorExperience: 'investorExperience',
    identityCheck: 'identityCheck',
    taxInformationRequired: 'taxInformationRequired',
    saveDepositAccountConnection: 'saveDepositAccountConnection',
  };

  const steps = useMemo(() => {
    return Object.values(registerOverviewSteps).filter(
      (x) =>
        !!registerOnlyFlow.regOnlyWalletAndTaxStep ||
        (x !== registerOverviewSteps.saveDepositAccountConnection &&
          x !== registerOverviewSteps.taxInformationRequired),
    );
  }, [registerOnlyFlow.regOnlyWalletAndTaxStep]);

  return { overviewSteps: steps };
};

export default useProcessOverview;
